import { createContext, useContext, ReactNode, useState, useCallback } from "react";

interface AddNodeContextType {
  sourceNodeId: string | null;
  sourceHandleId: string | null;
  isAddingNode: boolean;
  setAddNodeSource: (nodeId: string, handleId?: string) => void;
  clearAddNodeSource: () => void;
}

const AddNodeContext = createContext<AddNodeContextType | null>(null);

export function AddNodeProvider({ children }: { children: ReactNode }) {
  const [sourceNodeId, setSourceNodeId] = useState<string | null>(null);
  const [sourceHandleId, setSourceHandleId] = useState<string | null>(null);

  const setAddNodeSource = useCallback((nodeId: string, handleId?: string) => {
    setSourceNodeId(nodeId);
    setSourceHandleId(handleId || null);
  }, []);

  const clearAddNodeSource = useCallback(() => {
    setSourceNodeId(null);
    setSourceHandleId(null);
  }, []);

  const isAddingNode = sourceNodeId !== null;

  return (
    <AddNodeContext.Provider
      value={{
        sourceNodeId,
        sourceHandleId,
        isAddingNode,
        setAddNodeSource,
        clearAddNodeSource,
      }}
    >
      {children}
    </AddNodeContext.Provider>
  );
}

export function useAddNodeContext() {
  const context = useContext(AddNodeContext);
  if (!context) {
    throw new Error("useAddNodeContext must be used within AddNodeProvider");
  }
  return context;
}
